/* global I18n */

import React, {useState} from "react"
import KenhubModal from "../kenhub_modal"
import QuizModeSelector from "./quiz_mode_selector"
import PreviewHeader from "./preview_header"
import {use_modal} from "../../modal_provider"
import start_trainer from "../../start_trainer"
import TerminologyModal from "../terminology_modal"
import ajax from "../../ajax"

function QuizModeSelectorModal({
  quiz_slug,
  quiz_data,
  summary_path,
  tracking_data,
  custom_quiz_selection,
  exam_conditions = false,
  initial_quiz_mode = "study_mode",
  is_open,
  inline,
  title,
  cta,
  on_close,
  on_loading_error = () => { },
  on_loading_success = () => { }
}) {
  const {open_modal, close_modal} = use_modal()
  const [quiz, set_quiz] = useState(quiz_data)
  const [quiz_mode, set_quiz_mode] = useState(initial_quiz_mode)
  const [quiz_configuration, set_quiz_configuration] = useState()

  function load_data() {
    if (quiz_data) return

    get_quiz_data(quiz_slug, custom_quiz_selection).then(
      data => {
        set_quiz(data)
        on_loading_success()
      },
      on_loading_error
    )
  }

  function on_click(mode, configuration) {
    set_quiz_mode(mode)
    set_quiz_configuration(configuration)
    if (window.gon.current_user?.term_language) {
      start_trainer(quiz, mode, configuration, tracking_data, summary_path)
    } else {
      open_modal("terminology")
    }
    return Promise.resolve()
  }

  function submit_terminology_modal() {
    return start_trainer(
      quiz,
      quiz_mode,
      quiz_configuration,
      tracking_data,
      summary_path
    )
  }

  return (
    <>
      {inline &&
        <QuizModeSelector{...{
          cta,
          quiz,
          title,
          on_click,
          exam_conditions,
          initial_quiz_mode
        }}/>}
      {!inline &&
        <KenhubModal
          identifier="quiz_mode_selector"
          class_name={
            `modal-medium quiz-mode-selector-modal
            ${quiz && !quiz.can_train ? "modal-with-banner" : ""}`
          }
          label={I18n.t("js.quiz_mode_selector.title")}
          on_close={on_close}
          on_open={load_data}
          is_open={is_open}
        >
          {quiz && !quiz.can_train && <PreviewHeader/>}
          <div className="modal-header">
            <button className="btn btn-link close" onClick={close_modal}>
            </button>
          </div>
          <QuizModeSelector{...{
            cta,
            quiz,
            title,
            on_click,
            exam_conditions,
            initial_quiz_mode
          }}/>
        </KenhubModal>}
      <TerminologyModal
        on_close={on_close}
        on_form_submit={submit_terminology_modal}
      />
    </>
  )
}

function get_quiz_data(slug, selection) {
  // custom quiz
  if (slug === "custom-quiz-1" || (/^cq_/).test(slug)) {
    return ajax.post(
      `${window.gon.api_custom_quizzes_path}/${slug}`,
      {selection, locale: window.gon.locale}
    )
  } else if (!slug) {
    // review quiz
    return ajax.get(window.gon.review_quiz_api_user_path)
  }

  // normal quiz
  return ajax.get(`/api/quizzes/${slug}.json?locale=${window.gon.locale}`)
}

export default QuizModeSelectorModal
